document.documentElement.classList.remove('no-js');

/* ---------------- Order tracking request form ---------------- */
(function () {
  var submitBtn = document.querySelector('[data-order-track-submit]');
  if (!submitBtn) return;

  var numberInput = document.querySelector('[data-order-track-number]');
  var emailInput = document.querySelector('[data-order-track-email]');
  var successMsg = document.querySelector('[data-order-track-success]');
  var errorMsg = document.querySelector('[data-order-track-error]');

  submitBtn.addEventListener('click', function () {
    var orderNumber = (numberInput.value || '').trim();
    var email = (emailInput.value || '').trim();

    errorMsg.style.display = 'none';
    successMsg.style.display = 'none';

    if (!orderNumber || !email || email.indexOf('@') === -1) {
      errorMsg.style.display = 'block';
      return;
    }

    submitBtn.textContent = 'Gönderiliyor…';
    submitBtn.disabled = true;

    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', 'siparis-takip-talebi');
    fd.append('contact[note]', 'Sipariş takip talebi — Sipariş No: ' + orderNumber);

    fetch(window.location.pathname, { method: 'POST', body: fd })
      .then(function () {
        successMsg.style.display = 'block';
        numberInput.value = '';
        emailInput.value = '';
        submitBtn.textContent = 'Sipariş Durumumu Sor';
        submitBtn.disabled = false;
      })
      .catch(function () {
        successMsg.style.display = 'block';
        submitBtn.textContent = 'Sipariş Durumumu Sor';
        submitBtn.disabled = false;
      });
  });
})();

/* ---------------- Predictive search (live results while typing) ---------------- */
(function () {
  var input = document.querySelector('[data-predictive-search-input]');
  var results = document.querySelector('[data-predictive-search-results]');
  if (!input || !results) return;

  var debounceTimer = null;
  var currentController = null;

  function renderResults(data, term) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];

    if (!products.length) {
      results.innerHTML =
        '<div class="search-drawer__empty">' +
          '<p>"' + term + '" için sonuç bulunamadı.</p>' +
        '</div>';
      results.classList.add('is-visible');
      return;
    }

    var html = '<ul class="search-drawer__list">';
    products.forEach(function (p) {
      var image = p.featured_image ? p.featured_image.url : (p.image || '');
      var imageUrl = image ? image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_200x200$1$2') : '';
      var priceCents = Math.round(parseFloat(p.price) * 100);
      html +=
        '<li class="search-drawer__item">' +
          '<a href="' + p.url + '">' +
            (imageUrl ? '<img src="' + imageUrl + '" alt="" loading="lazy">' : '<span class="search-drawer__item-placeholder"></span>') +
            '<span class="search-drawer__item-info">' +
              '<span class="search-drawer__item-title">' + p.title + '</span>' +
              '<span class="search-drawer__item-price">' + themeFormatMoney(priceCents) + '</span>' +
            '</span>' +
          '</a>' +
        '</li>';
    });
    html += '</ul>';
    html +=
      '<a href="/search?q=' + encodeURIComponent(term) + '&type=product" class="search-drawer__view-all">' +
        '"' + term + '" için tüm sonuçları gör &rarr;' +
      '</a>';

    results.innerHTML = html;
    results.classList.add('is-visible');
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();

    clearTimeout(debounceTimer);
    if (currentController) currentController.abort();

    if (term.length < 2) {
      results.classList.remove('is-visible');
      results.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(function () {
      currentController = new AbortController();
      var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

      fetch(url, { signal: currentController.signal })
        .then(function (res) { return res.json(); })
        .then(function (data) { renderResults(data, term); })
        .catch(function (err) {
          if (err.name !== 'AbortError') results.classList.remove('is-visible');
        });
    }, 250);
  });
})();

/* ---------------- Quick Shop modal ---------------- */
(function () {
  var modal = document.querySelector('[data-quickshop-modal]');
  if (!modal) return;

  var body = modal.querySelector('[data-quickshop-body]');
  var closeBtns = modal.querySelectorAll('[data-quickshop-close]');

  function open() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quickshop-open]');
    if (!trigger) return;
    e.preventDefault();
    var url = trigger.getAttribute('data-quickshop-url');
    body.innerHTML = '<div class="quickshop-modal__loading">Yükleniyor…</div>';
    open();

    fetch(url + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) { renderProduct(product, url); })
      .catch(function () {
        body.innerHTML = '<div class="quickshop-modal__loading">Ürün yüklenemedi. <a href="' + url + '">Ürün sayfasına git</a></div>';
      });
  });

  function renderProduct(product, url) {
    var hasOptions = product.options && product.options.length && product.variants.length > 1;
    var optionName = hasOptions ? product.options[0] : null;

    var imageUrl = product.featured_image ? product.featured_image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_600x$1$2') : '';

    var html = '<div class="quickshop-modal__image">' +
      (imageUrl ? '<img src="' + imageUrl + '" alt="' + product.title.replace(/"/g, '') + '">' : '') +
      '</div>' +
      '<div class="quickshop-modal__info">' +
        '<p class="quickshop-modal__vendor">' + (product.vendor || '') + '</p>' +
        '<h3 class="quickshop-modal__title">' + product.title + '</h3>' +
        '<p class="quickshop-modal__price" data-quickshop-price>' + themeFormatMoney(product.variants[0].price) + '</p>';

    if (hasOptions) {
      html += '<div class="quickshop-modal__options"><p class="quickshop-modal__options-label">' + optionName + '</p><div class="quickshop-modal__option-values">';
      product.variants.forEach(function (v, i) {
        html += '<button type="button" class="quickshop-modal__option-value' + (i === 0 ? ' is-active' : '') + (v.available ? '' : ' is-disabled') + '" data-quickshop-variant="' + v.id + '" data-quickshop-price-cents="' + v.price + '">' + v.option1 + '</button>';
      });
      html += '</div></div>';
    }

    html += '<input type="hidden" data-quickshop-selected-variant value="' + product.variants[0].id + '">' +
      '<button type="button" class="btn btn--primary quickshop-modal__add" data-quickshop-add' + (product.variants[0].available ? '' : ' disabled') + '>' +
      (product.variants[0].available ? 'Sepete Ekle' : 'Tükendi') +
      '</button>' +
      '<a href="' + url + '" class="quickshop-modal__view-full">Tüm detayları gör &rarr;</a>' +
      '</div>';

    body.innerHTML = html;

    var selectedInput = body.querySelector('[data-quickshop-selected-variant]');
    var addBtn = body.querySelector('[data-quickshop-add]');
    var priceEl = body.querySelector('[data-quickshop-price]');

    body.querySelectorAll('[data-quickshop-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-disabled')) return;
        body.querySelectorAll('[data-quickshop-variant]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selectedInput.value = btn.getAttribute('data-quickshop-variant');
        priceEl.textContent = themeFormatMoney(btn.getAttribute('data-quickshop-price-cents'));
        addBtn.textContent = 'Sepete Ekle';
        addBtn.removeAttribute('disabled');
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        addBtn.textContent = 'Ekleniyor…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: selectedInput.value, quantity: 1 })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            close();
            if (typeof window.themeOpenCartDrawer === 'function') {
              window.themeOpenCartDrawer();
            } else {
              var cartOpenBtn = document.querySelector('[data-cart-drawer-open]');
              if (cartOpenBtn) cartOpenBtn.click();
            }
          })
          .catch(function () {
            addBtn.textContent = 'Bir hata oluştu';
          });
      });
    }
  }
})();

/* ---------------- Login: forgot password toggle ---------------- */
(function () {
  var loginPanel = document.getElementById('login');
  var recoverPanel = document.querySelector('[data-recover-panel]');
  if (!loginPanel || !recoverPanel) return;

  function showRecover() {
    loginPanel.classList.add('auth-panel--hidden');
    recoverPanel.classList.remove('auth-panel--hidden');
  }
  function showLogin() {
    recoverPanel.classList.add('auth-panel--hidden');
    loginPanel.classList.remove('auth-panel--hidden');
  }

  document.querySelectorAll('[data-recover-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); showRecover(); });
  });
  document.querySelectorAll('[data-recover-close]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); showLogin(); });
  });
  if (window.location.hash === '#recover') showRecover();
})();

/* ---------------- Account: address form toggle ---------------- */
(function () {
  document.querySelectorAll('[data-address-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-address-toggle');
      var form = document.querySelector('[data-address-form="' + id + '"]');
      if (form) form.style.display = form.style.display === 'none' ? 'block' : 'none';
    });
  });
  document.querySelectorAll('[data-address-cancel]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-address-cancel');
      var form = document.querySelector('[data-address-form="' + id + '"]');
      if (form) form.style.display = 'none';
    });
  });
})();

/* ---------------- Gift card: recipient fields toggle ---------------- */
(function () {
  var toggle = document.querySelector('[data-recipient-toggle]');
  var fields = document.querySelector('[data-recipient-fields]');
  var emailInput = document.querySelector('[data-recipient-email]');
  if (!toggle || !fields) return;

  function sync() {
    var isOn = toggle.checked;
    fields.classList.toggle('is-visible', isOn);
    if (emailInput) {
      if (isOn) emailInput.setAttribute('required', 'required');
      else emailInput.removeAttribute('required');
    }
  }

  toggle.addEventListener('change', sync);
  sync();
})();

/* ---------------- Measure real header height for sticky offsets ---------------- */
(function () {
  function setHeaderHeight() {
    var header = document.querySelector('.site-header');
    var announcement = document.querySelector('.announcement-bar');
    var h = (header ? header.offsetHeight : 0) + (announcement ? announcement.offsetHeight : 0);
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('load', setHeaderHeight);
})();

/* ---------------- Hero carousel ---------------- */
(function () {
  var carousel = document.querySelector('[data-hero-carousel]');
  if (!carousel) return;

  var slides = carousel.querySelectorAll('[data-hero-slide]');
  var dots = carousel.querySelectorAll('[data-hero-dot]');
  var prevBtn = carousel.querySelector('[data-hero-prev]');
  var nextBtn = carousel.querySelector('[data-hero-next]');
  if (slides.length < 2) return;

  var current = 0;
  var autoplaySeconds = parseFloat(getComputedStyle(carousel).getPropertyValue('--hero-autoplay')) || 0;
  var timer = null;

  function show(index) {
    current = (index + slides.length) % slides.length;
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
  }

  function next() { show(current + 1); }
  function prev() { show(current - 1); }

  function startAutoplay() {
    if (autoplaySeconds <= 0) return;
    stopAutoplay();
    timer = setInterval(next, autoplaySeconds * 1000);
  }
  function stopAutoplay() {
    if (timer) clearInterval(timer);
  }

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { show(i); startAutoplay(); });
  });
  if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
  if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });

  carousel.addEventListener('mouseenter', stopAutoplay);
  carousel.addEventListener('mouseleave', startAutoplay);

  startAutoplay();
})();

/* ---------------- Back to top ---------------- */
(function () {
  var btn = document.querySelector('[data-back-to-top]');
  if (!btn) return;
  window.addEventListener('scroll', function () {
    btn.classList.toggle('is-visible', window.scrollY > 600);
  });
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

/* ---------------- Size guide modal ---------------- */
(function () {
  var modal = document.querySelector('[data-size-guide-modal]');
  var openBtn = document.querySelector('[data-size-guide-open]');
  if (!modal || !openBtn) return;

  function open() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  }
  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }
  openBtn.addEventListener('click', open);
  modal.querySelectorAll('[data-size-guide-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
})();

/* ---------------- Description: Read More toggle (product + collection) ---------------- */
(function () {
  function wireToggle(descSelector, toggleSelector) {
    var desc = document.querySelector(descSelector);
    var toggle = document.querySelector(toggleSelector);
    if (!desc || !toggle) return;

    desc.classList.add('is-collapsed');
    toggle.addEventListener('click', function () {
      var expanded = desc.classList.toggle('is-collapsed') === false;
      toggle.textContent = expanded ? 'Daha Az Göster' : 'Devamını Oku';
    });
  }

  wireToggle('[data-description]', '[data-description-toggle]');
  wireToggle('[data-collection-description]', '[data-collection-description-toggle]');
})();

/* ---------------- Size calculator: height/weight -> recommended size ---------------- */
(function () {
  var calc = document.querySelector('[data-size-calculator]');
  if (!calc) return;

  var heightInput = calc.querySelector('[data-size-calc-height]');
  var weightInput = calc.querySelector('[data-size-calc-weight]');
  var submitBtn = calc.querySelector('[data-size-calc-submit]');
  var resultBox = calc.querySelector('[data-size-calc-result]');

  var sizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
  var numericMap = { 'XS': ['34', '36'], 'S': ['36', '38'], 'M': ['38', '40'], 'L': ['40', '42'], 'XL': ['42', '44'], 'XXL': ['44', '46'], '3XL': ['46', '48'] };
  var gender = calc.getAttribute('data-default-gender') === 'women' ? 'women' : 'men';
  var genderBtns = calc.querySelectorAll('[data-size-calc-gender]');

  function syncGenderButtons() {
    genderBtns.forEach(function (b) {
      var active = b.getAttribute('data-size-calc-gender') === gender;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  genderBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      gender = b.getAttribute('data-size-calc-gender');
      syncGenderButtons();
      resultBox.style.display = 'none';
    });
  });
  syncGenderButtons();

  function baseSizeIndexWomen(weight) {
    if (weight < 50) return 0;
    if (weight < 58) return 1;
    if (weight < 66) return 2;
    if (weight < 76) return 3;
    if (weight < 88) return 4;
    if (weight < 100) return 5;
    return 6;
  }

  function baseSizeIndex(weight) {
    if (gender === 'women') return baseSizeIndexWomen(weight);
    if (weight < 58) return 0;
    if (weight < 68) return 1;
    if (weight < 78) return 2;
    if (weight < 90) return 3;
    if (weight < 105) return 4;
    if (weight < 120) return 5;
    return 6;
  }

  function recommendedSize(height, weight) {
    var idx = baseSizeIndex(weight);
    if (gender === 'women') {
      if (height >= 178) idx += 1;
      else if (height <= 155) idx -= 1;
    } else {
      if (height >= 190) idx += 1;
      else if (height <= 162) idx -= 1;
    }
    idx = Math.max(0, Math.min(sizes.length - 1, idx));
    return sizes[idx];
  }

  function showResult(html, isError) {
    resultBox.className = 'size-calculator__result' + (isError ? ' size-calculator__result--error' : '');
    resultBox.innerHTML = html;
    resultBox.style.display = 'block';
    setTimeout(function () {
      resultBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }

  submitBtn.addEventListener('click', function () {
    heightInput.blur();
    weightInput.blur();
    var h = parseFloat(heightInput.value);
    var w = parseFloat(weightInput.value);

    if (!h || !w || h < 140 || h > 220 || w < 35 || w > 180) {
      showResult('Lütfen geçerli bir boy (140–220 cm) ve kilo (35–180 kg) girin.', true);
      return;
    }

    var size = recommendedSize(h, w);
    showResult(
      '<span style="display:block;font-size:11px;text-transform:uppercase;letter-spacing:0.05em;opacity:0.6;">Önerilen bedeniniz</span>' +
      '<strong>' + size + '</strong>' +
      '<span style="display:block;font-size:12px;opacity:0.55;">Bu genel bir tahmindir; kesim ürüne göre farklılık gösterebilir.</span>',
      false
    );

    document.querySelectorAll('.product-detail__option-value').forEach(function (btn) {
      var val = (btn.getAttribute('data-option-value') || '').trim().toUpperCase();
      var match = val === size || (gender === 'women' && numericMap[size].indexOf(val) !== -1);
      if (match && !btn.classList.contains('is-disabled')) {
        btn.click();
      }
    });
  });

  [heightInput, weightInput].forEach(function (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        submitBtn.click();
      }
    });
    input.addEventListener('focus', function () {
      setTimeout(function () {
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 300);
    });
  });
})();

/* ---------------- Recently Viewed: track + render ---------------- */
(function () {
  var STORAGE_KEY = 'maisonMenRecentlyViewed';
  var MAX_ITEMS = 10;

  function getViewed() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveViewed(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  var isProductPage = /^\/products\//.test(window.location.pathname);
  var currentProductUrl = isProductPage ? window.location.pathname.split('?')[0] : null;

  if (currentProductUrl) {
    var list = getViewed().filter(function (u) { return u !== currentProductUrl; });
    list.unshift(currentProductUrl);
    saveViewed(list.slice(0, MAX_ITEMS));
  }

  function buildCardHtml(p, url) {
    var image = p.featured_image || (p.images && p.images[0]) || '';
    var imageUrl = image ? image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_600x$1$2') : '';
    return (
      '<div class="product-card">' +
        '<a href="' + url + '" class="product-card__media">' +
          (imageUrl ? '<img class="product-card__image product-card__image--primary" src="' + imageUrl + '" alt="" loading="lazy">' : '<div class="product-card__placeholder"></div>') +
        '</a>' +
        '<div class="product-card__info">' +
          '<p class="product-card__vendor">' + (p.vendor || '') + '</p>' +
          '<a href="' + url + '" class="product-card__title">' + p.title + '</a>' +
          '<p class="product-card__price"><span>' + themeFormatMoney(p.price) + '</span></p>' +
        '</div>' +
      '</div>'
    );
  }

  var sections = document.querySelectorAll('[data-recently-viewed]');
  if (sections.length) {
    var viewedForGrid = getViewed().filter(function (u) { return u !== currentProductUrl; });
    if (viewedForGrid.length > 0) {
      var urlsToShow = viewedForGrid.slice(0, 8);
      Promise.all(urlsToShow.map(function (url) {
        return fetch(url + '.js').then(function (res) { return res.ok ? res.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var html = '';
        products.forEach(function (p, i) {
          if (p) html += buildCardHtml(p, urlsToShow[i]);
        });
        if (html) {
          sections.forEach(function (section) {
            var grid = section.querySelector('[data-recently-viewed-grid]');
            if (grid) grid.innerHTML = html;
            section.style.display = '';
          });
        }
      });
    }
  }

  var compactContainer = document.querySelector('[data-recently-viewed-compact]');
  var compactList = document.querySelector('[data-recently-viewed-compact-list]');
  if (compactContainer && compactList) {
    var compactUrls = getViewed().slice(0, 4);
    if (compactUrls.length > 0) {
      Promise.all(compactUrls.map(function (url) {
        return fetch(url + '.js').then(function (res) { return res.ok ? res.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var html = '';
        products.forEach(function (p, i) {
          if (!p) return;
          var url = compactUrls[i];
          var image = p.featured_image || (p.images && p.images[0]) || '';
          var imageUrl = image ? image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_200x$1$2') : '';
          html +=
            '<a href="' + url + '" class="cart-drawer__recently-viewed-item">' +
              (imageUrl ? '<img src="' + imageUrl + '" alt="">' : '') +
              '<span>' + themeFormatMoney(p.price) + '</span>' +
            '</a>';
        });
        if (html) {
          compactList.innerHTML = html;
          compactContainer.style.display = 'block';
        }
      });
    }
  }
})();

/* ---------------- Related products (native Shopify recommendations) ---------------- */
(function () {
  var targets = document.querySelectorAll('[data-recommendations-target]');
  targets.forEach(function (target) {
    var url = target.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var section = doc.querySelector('.related-products, .complete-look');
        if (section) target.innerHTML = section.outerHTML;
      })
      .catch(function () {});
  });
})();

/* ---------------- Mobile sticky add-to-cart bar ---------------- */
(function () {
  var bar = document.querySelector('[data-mobile-sticky-cart]');
  var mainAddBtn = document.querySelector('#MainProductForm [data-add-to-cart]');
  if (!bar || !mainAddBtn) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      bar.classList.toggle('is-visible', !entry.isIntersecting && window.matchMedia('(max-width: 899px)').matches);
    });
  }, { threshold: 0 });
  observer.observe(mainAddBtn);

  window.addEventListener('resize', function () {
    if (!window.matchMedia('(max-width: 899px)').matches) bar.classList.remove('is-visible');
  });

  var stickyBtn = bar.querySelector('[data-mobile-sticky-add]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      mainAddBtn.click();
    });
  }
})();

/* ---------------- Newsletter popup ---------------- */
(function () {
  var popup = document.querySelector('[data-newsletter-popup]');
  if (!popup) return;

  var enabled = true; // controlled by theme setting via data attribute if needed
  var delaySeconds = window.theme && window.theme.newsletterPopupDelay ? window.theme.newsletterPopupDelay : 4;
  var storageKey = 'maisonMenNewsletterPopupSeen';

  function openPopup() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    try { sessionStorage.setItem(storageKey, '1'); } catch (e) {}
  }

  popup.querySelectorAll('[data-newsletter-close]').forEach(function (el) {
    el.addEventListener('click', closePopup);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  var alreadySeen = false;
  try { alreadySeen = sessionStorage.getItem(storageKey) === '1'; } catch (e) {}

  if (enabled && !alreadySeen) {
    setTimeout(openPopup, delaySeconds * 1000);
  }

  // If the form posted successfully (server re-render), keep it open to show the success message
  if (popup.querySelector('.newsletter-popup__success')) {
    openPopup();
  }
})();

/* ---------------- Catalog dropdowns (Kadın / Erkek / Ek menü) ---------------- */
(function () {
  var catalogs = Array.prototype.slice.call(document.querySelectorAll('[data-catalog]'));
  if (!catalogs.length) return;

  function setState(catalog, open) {
    var toggle = catalog.querySelector('[data-catalog-toggle]');
    catalog.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAll(except) {
    catalogs.forEach(function (c) { if (c !== except) setState(c, false); });
  }

  catalogs.forEach(function (catalog) {
    var toggle = catalog.querySelector('[data-catalog-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = !catalog.classList.contains('is-open');
      closeAll(catalog);
      setState(catalog, willOpen);
    });
  });
  document.addEventListener('click', function (e) {
    catalogs.forEach(function (c) {
      if (c.classList.contains('is-open') && !c.contains(e.target)) setState(c, false);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
})();

/* ---------------- Mobile menu ---------------- */
(function () {
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  var closeBtn = document.querySelector('[data-mobile-menu-close]');
  if (!toggle || !menu) return;

  var backdrop = document.createElement('div');
  backdrop.className = 'mobile-menu-backdrop';
  document.body.appendChild(backdrop);

  function open() {
    menu.classList.add('is-open');
    backdrop.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
  }
  function close() {
    menu.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  backdrop.addEventListener('click', close);
})();

/* ---------------- Search drawer ---------------- */
(function () {
  var toggle = document.querySelector('[data-search-toggle]');
  var drawer = document.querySelector('[data-search-drawer]');
  var closeBtn = document.querySelector('[data-search-close]');
  if (!toggle || !drawer) return;

  function open() {
    drawer.classList.add('is-open');
    var input = drawer.querySelector('input[type="search"]');
    if (input) setTimeout(function () { input.focus(); }, 150);
  }
  function close() { drawer.classList.remove('is-open'); }

  toggle.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();

/* ---------------- Money formatter (uses shop.money_format template) ---------------- */
function themeFormatMoney(cents) {
  var format = window.themeMoneyFormat || '{{amount}} TL';
  var amount = (cents / 100).toFixed(2).replace('.', ',');
  return format.replace(/\{\{\s*amount\s*\}\}/, amount);
}

/* ---------------- Product variant selection: live availability + price ---------------- */
(function () {
  var form = document.getElementById('MainProductForm');
  var dataEl = document.querySelector('[data-product-json]');
  if (!form || !dataEl) return;

  var product;
  try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!product || !product.variants) return;

  var select = form.querySelector('[data-product-select]');
  var priceWrap = document.querySelector('[data-product-price]');
  var addBtn = form.querySelector('[data-add-to-cart]');
  var optionCount = product.options ? product.options.length : 1;

  var selected = [];
  for (var i = 0; i < optionCount; i++) {
    var activeBtn = form.querySelector('.product-detail__option-value.is-active[data-option-index="' + i + '"]');
    selected[i] = activeBtn ? activeBtn.getAttribute('data-option-value') : null;
  }

  function optionValuesOf(variant) { return [variant.option1, variant.option2, variant.option3]; }

  function findVariant() {
    return product.variants.filter(function (v) {
      var opts = optionValuesOf(v);
      for (var i = 0; i < optionCount; i++) {
        if (selected[i] && opts[i] !== selected[i]) return false;
      }
      return true;
    })[0];
  }

  function isCombinationAvailable(index, value) {
    var test = selected.slice();
    test[index] = value;
    return product.variants.some(function (v) {
      var opts = optionValuesOf(v);
      for (var i = 0; i < optionCount; i++) {
        if (test[i] && opts[i] !== test[i]) return false;
      }
      return v.available;
    });
  }

  function renderPrice(variant) {
    if (!priceWrap || !variant) return;
    var html = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      html += '<span class="product-detail__price--sale">' + themeFormatMoney(variant.price) + '</span>';
      html += '<span class="product-detail__price--compare">' + themeFormatMoney(variant.compare_at_price) + '</span>';
      html += '<span class="product-detail__price--off">%' + pct + ' indirim</span>';
    } else {
      html += themeFormatMoney(variant.price);
    }
    priceWrap.innerHTML = html;

    var stickyPrice = document.querySelector('[data-mobile-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = themeFormatMoney(variant.price);
    var stickyBtn = document.querySelector('[data-mobile-sticky-add]');
    if (stickyBtn) {
      stickyBtn.disabled = !variant.available;
      stickyBtn.textContent = variant.available ? 'Sepete Ekle' : 'Tükendi';
    }

    var stockWarning = document.querySelector('[data-stock-warning]');
    var stockWarningText = document.querySelector('[data-stock-warning-text]');
    if (stockWarning && stockWarningText) {
      if (variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
        stockWarningText.textContent = 'Son ' + variant.inventory_quantity + ' adet! Stok tükeniyor.';
        stockWarning.style.display = 'flex';
      } else {
        stockWarning.style.display = 'none';
      }
    }
  }

  function updateUI() {
    var variant = findVariant();

    form.querySelectorAll('.product-detail__option-value').forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-option-index'), 10);
      var val = btn.getAttribute('data-option-value');
      btn.classList.toggle('is-active', selected[idx] === val);
      btn.classList.toggle('is-disabled', !isCombinationAvailable(idx, val));
    });

    form.querySelectorAll('[data-option-selected-0], [data-option-selected-1], [data-option-selected-2]').forEach(function (el, idx) {
      if (selected[idx]) el.textContent = selected[idx];
    });

    if (variant) {
      if (select) select.value = variant.id;
      renderPrice(variant);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? addBtn.getAttribute('data-label-add')
          : addBtn.getAttribute('data-label-soldout');
      }
    } else if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = addBtn.getAttribute('data-label-soldout');
    }
  }

  form.querySelectorAll('.product-detail__option-value').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-disabled')) {
        showNotifyPanel(btn.getAttribute('data-option-value'));
        return;
      }
      var idx = parseInt(btn.getAttribute('data-option-index'), 10);
      selected[idx] = btn.getAttribute('data-option-value');
      updateUI();
    });
  });

  var notifyPanel = document.querySelector('[data-notify-panel]');
  var notifySizeLabel = document.querySelector('[data-notify-size-label]');
  var notifyEmailInput = document.querySelector('[data-notify-email]');
  var notifySubmitBtn = document.querySelector('[data-notify-submit]');
  var notifySuccessMsg = document.querySelector('[data-notify-success]');

  function showNotifyPanel(sizeValue) {
    if (!notifyPanel) return;
    if (notifySizeLabel) notifySizeLabel.textContent = sizeValue;
    notifyPanel.style.display = 'block';
    if (notifySuccessMsg) notifySuccessMsg.style.display = 'none';
    notifyPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  if (notifySubmitBtn) {
    notifySubmitBtn.addEventListener('click', function () {
      var email = (notifyEmailInput.value || '').trim();
      if (!email || email.indexOf('@') === -1) {
        notifyEmailInput.focus();
        return;
      }
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', 'restock-request');
      fd.append('contact[note]', 'Stok bildirimi istendi: ' + document.title + ' — Beden: ' + (notifySizeLabel ? notifySizeLabel.textContent : ''));

      fetch(window.location.pathname, { method: 'POST', body: fd })
        .then(function () {
          notifySuccessMsg.style.display = 'block';
          notifyEmailInput.value = '';
        })
        .catch(function () {
          notifySuccessMsg.style.display = 'block';
        });
    });
  }

  updateUI();
})();

/* ---------------- Quantity stepper ---------------- */
(function () {
  document.querySelectorAll('.product-detail__quantity-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('[data-quantity-input]');
    var decrease = stepper.querySelector('[data-quantity-decrease]');
    var increase = stepper.querySelector('[data-quantity-increase]');
    if (!input) return;
    if (decrease) decrease.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (increase) increase.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
})();

/* ---------------- AJAX add to cart -> opens cart drawer ---------------- */
(function () {
  var form = document.getElementById('MainProductForm');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var addBtn = form.querySelector('[data-add-to-cart]');
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.dataset.originalLabel = addBtn.textContent;
      addBtn.textContent = addBtn.getAttribute('data-label-adding') || 'Ekleniyor…';
    }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        window.themeRenderCartDrawer(cart);
        window.themeOpenCartDrawer();
        window.themeUpdateCartCount(cart.item_count);
      })
      .catch(function () {
        window.location.href = '/cart';
      })
      .finally(function () {
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.dataset.originalLabel;
        }
      });
  });
})();

/* ---------------- Cart drawer: open/close, render, update, remove ---------------- */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var itemsWrap = drawer.querySelector('[data-cart-drawer-items]');
  var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
  var footer = drawer.querySelector('[data-cart-drawer-footer]');
  var countEl = drawer.querySelector('[data-cart-drawer-count]');

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-drawer-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          window.themeRenderCartDrawer(cart);
          open();
        });
    });
  });
  drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  function itemImage(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=200';
  }

  window.themeRenderCartDrawer = function (cart) {
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';

    if (!cart.items.length) {
      itemsWrap.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<p>Sepetiniz boş.</p>' +
          '<button type="button" class="btn btn--outline" data-cart-drawer-close>Alışverişe devam et</button>' +
        '</div>';
      if (footer) footer.style.display = 'none';
      drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      return;
    }

    if (footer) footer.style.display = '';

    itemsWrap.innerHTML = cart.items.map(function (item) {
      return (
        '<div class="cart-drawer__item" data-cart-item-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="cart-drawer__item-image">' +
            (item.image ? '<img src="' + itemImage(item.image) + '" alt="' + (item.product_title || '').replace(/"/g, '') + '">' : '') +
          '</a>' +
          '<div class="cart-drawer__item-info">' +
            '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
            (item.variant_title ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>' : '') +
            '<div class="cart-drawer__item-row">' +
              '<span class="cart-drawer__item-price">' + themeFormatMoney(item.final_price) + '</span>' +
              '<div class="cart-drawer__item-qty">' +
                '<button type="button" data-cart-qty="-1" data-key="' + item.key + '" data-quantity="' + item.quantity + '" aria-label="Azalt">&minus;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-cart-qty="1" data-key="' + item.key + '" data-quantity="' + item.quantity + '" aria-label="Artır">&plus;</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="cart-drawer__item-remove" data-cart-remove data-key="' + item.key + '" aria-label="Kaldır">&times;</button>' +
        '</div>'
      );
    }).join('');

    if (subtotalEl) subtotalEl.textContent = themeFormatMoney(cart.total_price);
  };

  function changeItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) { return res.json(); });
  }

  itemsWrap.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty]');
    var removeBtn = e.target.closest('[data-cart-remove]');

    if (qtyBtn) {
      var delta = parseInt(qtyBtn.getAttribute('data-cart-qty'), 10);
      var current = parseInt(qtyBtn.getAttribute('data-quantity'), 10);
      var next = Math.max(0, current + delta);
      changeItem(qtyBtn.getAttribute('data-key'), next).then(function (cart) {
        window.themeRenderCartDrawer(cart);
        window.themeUpdateCartCount(cart.item_count);
      });
    }

    if (removeBtn) {
      changeItem(removeBtn.getAttribute('data-key'), 0).then(function (cart) {
        window.themeRenderCartDrawer(cart);
        window.themeUpdateCartCount(cart.item_count);
      });
    }
  });

  window.themeOpenCartDrawer = open;
  window.themeCloseCartDrawer = close;
})();

/* ---------------- Header cart count ---------------- */
window.themeUpdateCartCount = function (count) {
  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
    el.textContent = count;
  });
};

/* ---------------- Product gallery: thumbnails, counter, arrow nav, lightbox ---------------- */
(function () {
  var galleries = document.querySelectorAll('[data-product-gallery]');
  galleries.forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var items = gallery.querySelectorAll('[data-gallery-item]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var currentEl = gallery.querySelector('[data-gallery-current]');
    if (!track || !items.length) return;

    function isHorizontal() { return window.matchMedia('(max-width: 899px)').matches; }

    function scrollToIndex(index) {
      var item = items[index];
      if (!item) return;
      var target = isHorizontal() ? item.offsetLeft : item.offsetTop;
      track.scrollTo({
        left: isHorizontal() ? target : 0,
        top: isHorizontal() ? 0 : target,
        behavior: 'smooth'
      });
    }

    function currentIndex() {
      var pos = isHorizontal() ? track.scrollLeft : track.scrollTop;
      var size = isHorizontal() ? track.clientWidth : track.clientHeight;
      return Math.min(items.length - 1, Math.round(pos / size));
    }

    function updateActive() {
      var idx = currentIndex();
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      if (currentEl) currentEl.textContent = idx + 1;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { scrollToIndex(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollToIndex(Math.max(0, currentIndex() - 1)); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollToIndex(Math.min(items.length - 1, currentIndex() + 1)); });

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActive, 80);
    });

    /* Lightbox */
    var lightbox = document.querySelector('[data-gallery-lightbox]');
    var openTrigger = gallery.querySelector('[data-gallery-open-lightbox]');
    if (!lightbox) return;

    var lbImage = lightbox.querySelector('[data-lightbox-image]');
    var lbCurrent = lightbox.querySelector('[data-lightbox-current]');
    var lbIndex = 0;
    var imgSrcs = Array.prototype.map.call(items, function (item) {
      var img = item.querySelector('img');
      if (!img) return '';
      return img.getAttribute('data-full-src') || img.getAttribute('src');
    });

    function openLightbox(index) {
      lbIndex = index;
      lbImage.src = imgSrcs[lbIndex];
      if (lbCurrent) lbCurrent.textContent = lbIndex + 1;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    function showLightboxIndex(index) {
      lbIndex = Math.max(0, Math.min(imgSrcs.length - 1, index));
      lbImage.src = imgSrcs[lbIndex];
      if (lbCurrent) lbCurrent.textContent = lbIndex + 1;
    }

    items.forEach(function (item, i) {
      var img = item.querySelector('[data-gallery-zoom]');
      if (!img) return;

      var downX = 0;
      var downY = 0;
      var pointerMoved = false;

      img.addEventListener('pointerdown', function (e) {
        downX = e.clientX;
        downY = e.clientY;
        pointerMoved = false;
      });
      img.addEventListener('pointermove', function (e) {
        if (Math.abs(e.clientX - downX) > 10 || Math.abs(e.clientY - downY) > 10) {
          pointerMoved = true;
        }
      });
      img.addEventListener('pointerup', function () {
        if (!pointerMoved) openLightbox(i);
      });
    });
    if (openTrigger) openTrigger.addEventListener('click', function () { openLightbox(currentIndex()); });

    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    var lbPrev = lightbox.querySelector('[data-lightbox-prev]');
    var lbNext = lightbox.querySelector('[data-lightbox-next]');
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    if (lbPrev) lbPrev.addEventListener('click', function () { showLightboxIndex(lbIndex - 1); });
    if (lbNext) lbNext.addEventListener('click', function () { showLightboxIndex(lbIndex + 1); });

    /* Swipe support */
    var touchStartX = 0;
    var touchStartY = 0;
    lbImage.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    lbImage.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) showLightboxIndex(lbIndex + 1);
        else showLightboxIndex(lbIndex - 1);
      }
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showLightboxIndex(lbIndex - 1);
      if (e.key === 'ArrowRight') showLightboxIndex(lbIndex + 1);
    });
  });
})();

/* ---------------- Mobile filter drawer ---------------- */
(function () {
  var toggle = document.querySelector('[data-filter-toggle]');
  var panel = document.querySelector('[data-filters]');
  var closeBtn = document.querySelector('[data-filter-close]');
  if (!toggle || !panel) return;

  var backdrop = document.createElement('div');
  backdrop.className = 'mobile-menu-backdrop';
  document.body.appendChild(backdrop);

  function open() {
    panel.classList.add('is-open');
    backdrop.classList.add('is-open');
  }
  function close() {
    panel.classList.remove('is-open');
    backdrop.classList.remove('is-open');
  }

  toggle.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  backdrop.addEventListener('click', close);
})();

/* ---------------- Product card color swatches ---------------- */
(function () {
  document.querySelectorAll('[data-product-card]').forEach(function (card) {
    var swatches = card.querySelectorAll('[data-swatch]');
    if (!swatches.length) return;

    var primaryImg = card.querySelector('[data-product-card-image]');
    var links = card.querySelectorAll('[data-product-card-link]');

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        swatch.classList.add('is-active');

        var newImage = swatch.getAttribute('data-swatch-image');
        var newUrl = swatch.getAttribute('data-swatch-url');

        if (primaryImg && newImage) primaryImg.setAttribute('src', newImage);
        if (newUrl) {
          links.forEach(function (link) { link.setAttribute('href', newUrl); });
        }
      });
    });
  });
})();

/* ---------------- Wishlist (local storage + working drawer) ---------------- */
(function () {
  var STORAGE_KEY = 'maisonMenWishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function cleanUrl(url) {
    if (!url) return url;
    return url.split('?')[0];
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function urlForButton(btn) {
    var explicit = btn.getAttribute('data-product-url');
    if (explicit) return cleanUrl(explicit);
    var card = btn.closest('.product-card');
    if (card) {
      var link = card.querySelector('a');
      if (link) return cleanUrl(link.getAttribute('href'));
    }
    return cleanUrl(window.location.pathname);
  }

  function initButtonStates() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var url = urlForButton(btn);
      btn.classList.toggle('is-active', list.indexOf(url) > -1);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var url = urlForButton(btn);
    var list = getWishlist();
    var idx = list.indexOf(url);
    if (idx > -1) {
      list.splice(idx, 1);
      btn.classList.remove('is-active');
    } else {
      list.push(url);
      btn.classList.add('is-active');
    }
    saveWishlist(list);
    updateCountBadges();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      if (urlForButton(b) === url) b.classList.toggle('is-active', list.indexOf(url) > -1);
    });
    if (typeof window.themeRenderWishlistDrawer === 'function' && document.querySelector('[data-wishlist-drawer].is-open')) {
      window.themeRenderWishlistDrawer();
    }
  });

  initButtonStates();
  updateCountBadges();

  /* ---- Drawer ---- */
  var drawer = document.querySelector('[data-wishlist-drawer]');
  if (!drawer) return;

  var itemsWrap = drawer.querySelector('[data-wishlist-drawer-items]');
  var countEl = drawer.querySelector('[data-wishlist-drawer-count]');

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    window.themeRenderWishlistDrawer();
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-wishlist-drawer-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  window.themeRenderWishlistDrawer = function () {
    var urls = getWishlist();
    if (countEl) countEl.textContent = urls.length ? '(' + urls.length + ')' : '';

    if (!urls.length) {
      itemsWrap.innerHTML =
        '<div class="wishlist-drawer__empty">' +
          '<p>Henüz favori ürününüz yok.</p>' +
          '<button type="button" class="btn btn--outline" data-wishlist-drawer-close>Alışverişe devam et</button>' +
        '</div>';
      itemsWrap.querySelectorAll('[data-wishlist-drawer-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      return;
    }

    itemsWrap.innerHTML = '<div class="wishlist-drawer__loading">Yükleniyor…</div>';

    Promise.all(urls.map(function (url) {
      return fetch(url + '.js').then(function (res) {
        if (!res.ok) throw new Error('not found');
        return res.json();
      }).catch(function () { return null; });
    })).then(function (products) {
      var html = '';
      products.forEach(function (p, i) {
        if (!p) return;
        var image = p.featured_image || (p.images && p.images[0]) || '';
        var imageUrl = image ? image + (image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
        html +=
          '<div class="wishlist-drawer__item">' +
            '<a href="' + urls[i] + '" class="wishlist-drawer__item-image">' +
              (imageUrl ? '<img src="' + imageUrl + '" alt="' + p.title.replace(/"/g, '') + '">' : '') +
            '</a>' +
            '<div class="wishlist-drawer__item-info">' +
              '<a href="' + urls[i] + '" class="wishlist-drawer__item-title">' + p.title + '</a>' +
              '<p class="wishlist-drawer__item-price">' + themeFormatMoney(p.price) + '</p>' +
            '</div>' +
            '<button type="button" class="wishlist-drawer__item-remove" data-wishlist-remove="' + urls[i] + '" aria-label="Kaldır">&times;</button>' +
          '</div>';
      });
      itemsWrap.innerHTML = html || '<div class="wishlist-drawer__empty"><p>Ürünler yüklenemedi.</p></div>';
    });
  };

  itemsWrap.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-wishlist-remove]');
    var closeBtn = e.target.closest('[data-wishlist-drawer-close]');
    if (removeBtn) {
      var targetUrl = removeBtn.getAttribute('data-wishlist-remove');
      var list = getWishlist().filter(function (u) { return u !== targetUrl; });
      saveWishlist(list);
      updateCountBadges();
      initButtonStates();
      window.themeRenderWishlistDrawer();
    }
    if (closeBtn) close();
  });

  drawer.querySelectorAll('[data-wishlist-drawer-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
})();
